import { render, staticRenderFns } from "./unallocatedStatsPoints.vue?vue&type=template&id=66347100&scoped=true&"
import script from "./unallocatedStatsPoints.vue?vue&type=script&lang=js&"
export * from "./unallocatedStatsPoints.vue?vue&type=script&lang=js&"
import style0 from "./unallocatedStatsPoints.vue?vue&type=style&index=0&id=66347100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66347100",
  null
  
)

export default component.exports